var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"active":_vm.active,"has-modal-card":""},on:{"close":function($event){return _vm.close()}}},[_c('ims-modal-card',{attrs:{"title":_vm.title},on:{"close":function($event){return _vm.close()}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }